import toast from "react-hot-toast";

function ToastComponent(userData, message, du) {
  if (true) return;
  if (userData.admin_id === 104) {
    toast.dismiss();
    toast.success(message, {
      duration: du === 1 ? Infinity : du,
    });
  }
}

export default ToastComponent;
